import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg/svg-decorator-blob-7.svg";
import Noimg from "../images/no_img.jpg";
import { getProduct, orderStatus } from "api/ProductApi";
import { currentRegister, filterFormatToDate } from "utility/Constant.js";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logoLoader from "images/Loader/logoLoader.png";
import Skeleton from "react-loading-skeleton";
import {
  deleteCustomerLike,
  createCustomerLike,
  createCustomerWish,
  deleteCustomerWish,
} from "api/Like&WishCountApi";
import { getBranchId, getCustomerId } from "utility/HeaderConfig";
import { getPageProductType } from "api/ProductTypeApi";
import { getAllProductSubCate } from "api/ProductSubCateApi";
import { getAllProductCate } from "api/ProductCategoryApi";
import no_data from "images/no_data.png";
import noimg from "../images/no_img.jpg";
import SkeletonLoader from "components/SkeletonLoader";
import { dayClose } from "../api/NewSchemeApi";
import moment from "moment";
import SEO from "components/headers/Seo";
import { useCartContext } from "context/UseCartContext";
import { Modal, Button, Accordion } from "react-bootstrap";
import Offcanvas from 'react-bootstrap/Offcanvas';
import TryOnItP from "../../src/images/Thanshiq/diamond mainpage/CityLocation/main/TryOnP.svg"
import similarP from "../../src/images/Thanshiq/diamond mainpage/CityLocation/main/SimilaritP.svg"
import bestSeller from "../../src/images/Thanshiq/diamond mainpage/bestsellerss.svg"
import plus from "../../src/images/Thanshiq/diamond mainpage/plus.svg"
import { getProductCate } from "../api/ProductCategoryApi";

import { Form, Row, Col } from "react-bootstrap";



const Container = tw.div`relative overflow-hidden`;
const TabContent = tw(motion.div)`block `;
const CardContainer = tw.div`mt-4 w-full relative`;

const Card = tw(
  motion.div
)`bg-white block mx-auto  sm:mx-0 no-underline hover:shadow-2xl rounded-lg duration-500 cursor-pointer `;
const CardImageContainer = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`bg-center bg-cover relative h-80 border border-gray-400 border-solid rounded-t-lg `}
`;
const CardText = tw.div`p-4 pb-1 text-gray-900 bg-gray-200 border border-gray-400 border-solid rounded-b-lg`;
const CardTitle = tw.h5`text-sm group-hover:text-yellow-600 no-underline  text-gray-600 lowercase`;
const CardContent = tw.p`mt-1 mb-2 text-sm font-medium text-custom-100  uppercase`;
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-pink-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-custom-100`}
`;
const CardRating = styled.div`
  ${tw` text-sm font-normal flex items-center justify-center  text-base text-gray-600 cursor-pointer rounded-full p-2 border-2 border-gray-400 border-dotted  bg-white`}
`;

export default ({ configImages }) => {
  let URL = window.location.href;
  const location = useLocation();
  const myparam = location.state;
  const navigate = useNavigate();

  const selectedPrice = location.state?.selectedPrice || null;
  const params = new URLSearchParams(location.search);
  const categoryId = params.get("category");
  const categoryData = location.state?.category;

  const [num, setNum] = useState(0);
  const [goldNum, setGoldNum] = useState(0);
  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(true);
  const [listLoading, setListLoading] = useState(true);
  const [size, setSize] = useState(21);
  const [productType, setProductType] = useState([]);
  const [productSubCate, setProductSubCate] = useState([]);
  const [productCategory, setCategoryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [dayClosedDates, setDayClosedDates] = useState("");
  const [orderStatusSale, setOrderStatusSale] = useState([]);
  const [orderStatusTransfer, setOrderStatusTransfer] = useState([]);
  const [orderStatusSold, setOrderStatusSold] = useState([]);
  const [likeState, setLikeState] = useState({});
  const [wishState, setWishState] = useState({});
  const [productFilter, setProductFilter] = useState({});
  const [subcategory, setSubCategory] = useState([]);
  const [occationCate, setOccationCate] = useState([]);
  const [category, setCategory] = useState([]);
  const [selectedList, setSelectedList] = useState({
    type: "",
    category: "",
    subCategory: "",
    gender: "",
    price: "",
    status: "available",
    occasion: '',
    minValue: '',
    maxValue: ''
  });
  const [price, setPrice] = useState({
    minValue: '',
    maxValue: ''
  })
  const [isHovered, setIsHovered] = useState(false);
  //eslint-disable-next-line
  const [lists, setLists] = useState(["gold", "silver", "diamond", "platinum"]);
  const { dispatch } = useCartContext();
  // const categories = [
  //   { id: 1, img: g1 },
  //   { id: 2, img: g2 }
  // ]
  const [hoveredCardId, setHoveredCardId] = useState();
  const handleMouseEnter = (id) => {
    setHoveredCardId(id);
  };
  const genderImages = [
    {
      title: "MALE",

      gender: "M",
    },
    {
      title: "FEMALE",

      gender: "F",
    },
    {
      title: "COUPLE",

      gender: "C",
    },
    {
      title: "KIDS",

      gender: "K",
    },
    {
      title: "UNISEX",

      gender: "U",
    },
  ]
  const [selectePrice, setSelectePrice] = useState(null);
  const handleNavigate = (value) => {
    navigate('/ProductList', {
      state: {
        selectedPrice: value,
        saleId: orderStatusSale,
        transferId: orderStatusTransfer,
        soldId: orderStatusSold

      }
    });
  };
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectGenderCategory, setSelectGenderCategory] = useState(null);
  const [selectGoldCategory, setSelectGoldCategory] = useState(null);
  const [selectEarringCategory, setSelectEarringCategory] = useState(null);
  const [selectPendantsCategory, setSelectPendantsCategory] = useState(null);
  const [selectMangalsutrasCategory, setSelectMangalsutrasCategory] = useState(null);



  const [selectPrice, setSelectPrice] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);


// const sortAfterApi = (products, sortValue) => {
//   if (sortValue === 'weight-low-high') {
//     return sortByGrossWeight([...products], 'asc');
//   } else if (sortValue === 'weight-high-low') {
//     return sortByGrossWeight([...products], 'desc');
//   } else if (sortValue === 'asc') {
//     return [...products].sort((a, b) => a.totalAmount - b.totalAmount);
//   } else if (sortValue === 'desc') {
//     return [...products].sort((a, b) => b.totalAmount - a.totalAmount);
//   }
//   return products;
// };

//     const sortByGrossWeight = (products, order) => {
//     return products.sort((a, b) => {
//       const weightA = parseFloat(JSON.parse(a.weight).grossWeight);
//       const weightB = parseFloat(JSON.parse(b.weight).grossWeight);
//       if (order === 'asc') {
//         return weightA - weightB;
//       } else {
//         return weightB - weightA;
//       }
//     });
//   };

  const sortOptions = [
    { label: "Best Sellers", route: "/BestSellingComponent" },
    { label: "New Arrivals", route: "/NewArrivals" },
    { label: "Trend On Shops", route: "/TrendOnShopComponent" },
    // { label: "Low to High", route: "" },
    // { label: "High to Low", route: "" },
    // { label: "Price: High To Low", route: "" },
  ];
  const priceImages = [
    { text: "< ₹25,000", value: "below-25000" },
    { text: "₹25,000 - ₹50,000", value: "25000-50000" },
    { text: "50,000 - ₹1,00,000", value: "50000-100000" },
    { text: "₹1,00,000 +", value: "100000-2500000" },
  ];

  const ProductListPriceFilter = [
    { text: "25,000 - 50,000", value: "25000-50000" },

  ];

  const handleGenderSelection = (gender) => {
    navigate("/ProductList", { state: { selectedGender: gender } });
  };
  const handleMouseLeave = () => {
    setHoveredCardId(null);
  };

  useEffect(() => {
    if (!myparam) return;

    const updatedList = { ...selectedList };

    if (myparam?.type) {
      updatedList.type = myparam.type.id;
      updatedList.typeName = myparam.type.name;
    }

    if (myparam?.category) {
      updatedList.category = myparam.category.id;
      updatedList.categoryName = myparam.category.categoryName;
      // updatedList.subCategoryName=myparam.subCategory.subCategoryName;
      updatedList.type = myparam.category.metaProdTypeId || updatedList.type;
      // updatedList.typeName = myparam.category.metaProdType || updatedList.typeName;
    }

    if (myparam?.occasionCate) {
      updatedList.occasion = myparam.occasionCate;
    }

    if (myparam?.selectedGender) {
      updatedList.genderName = myparam.selectedGender;
    }

    updatedList.subCategory = "";
    updatedList.subCategoryName = "";

    setSelectedList(updatedList);

    getProductType();
    getProducts(orderStatusSale, orderStatusTransfer, orderStatusSold);
    // eslint-disable-next-line
  }, [myparam]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleSortOptionClick = (option) => {
    console.log(`Sorting by: ${option}`);
    setIsModalOpen(false);
  };


  useEffect(() => {
    Promise.all([
      getOrderStatus(),
      getCategoryList(),
      getProductSub(),
      getSubCategoryList(),
      getOurExclusiveData()
    ])
    return () => { };
    //eslint-disable-next-line
  }, []);

  const getSubCategoryList = async () => {
    setListLoading(true);
    // let filter={ id: cateId.id}
    await getAllProductSubCate({}).then((data) => {
      const productResponse = data.response;
      setSubCategory(productResponse)
      setListLoading(false);
    });
  };
  const toPascalCase = (text) => {
    if (!text) return '';

    return text
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getProducts = (
    orderStatusSale,
    orderStatusTransfer,
    orderStatusSold
  ) => {
    setLoading(true);
    let filterData = {};
   if(myparam?.category?.displayName !== '108 MAHAVEL'){ 
     filterData = {
      productLabel: myparam?.occasionCate || '',
      userType: myparam?.selectedGender || '',
      allowCatalogue: 1,
      branch: getBranchId(),
      beforeCreatedAt: currentRegister(),
      // demoStatus: "Demo_Completed,Demo_Cancelled,Available_For_Demo",
      metaProdCateEnty:
        myparam && myparam?.category?.id
        || myparam?.categoryId?.id || myparam?.subcategory?.metaProdCateId
        || selectedList.category,
      metaProdTypeEnty:
        myparam && myparam?.type?.id
        || myparam.category?.metaProdTypeId || myparam?.subcategory?.metaProdTypeId
        || "",
      removeHp: "HP-",
      removeNTP: "NTP-",
      // sortType: true,
      statusId: `${myparam?.saleId?.[0] || orderStatusSale}, ${myparam?.transferId?.[0] || orderStatusTransfer}, ${myparam?.soldId?.[0] || orderStatusSold}`,
      sortBy: "asc",
      productSubcategory: category?.subCategoryName || subcategory?.id,
      productDemoStatus: "Available_For_Demo,Demo_Completed,Demo_Cancelled",

    };

    if (selectedPrice) {
      if (selectedPrice === "below-25000") {
        filterData.totalAmtFrom = '0';
        filterData.totalAmtTo = '25000';
      } else if (selectedPrice === "25000-50000") {
        filterData.totalAmtFrom = '25000';
        filterData.totalAmtTo = '50000';
      } else if (selectedPrice === "50000-100000") {
        filterData.totalAmtFrom = '50000';
        filterData.totalAmtTo = '100000';
      } else if (selectedPrice === "100000-2500000") {
        filterData.totalAmtFrom = '100000';
        filterData.totalAmtTo = '2500000';
      }
    } else if (selectedList) {
      filterData.totalAmtFrom = selectedList.minValue
      filterData.totalAmtTo = selectedList.maxValue
    }

    for (const key in filterData) {
      if (filterData[key] === '' || filterData[key] === undefined || filterData[key] === ", , ") {
        delete filterData[key];
      }
    }
  }else{
    filterData = {
          branch: getBranchId(),
          productLabel: '108 MAHAVEL',
          allowCatalogue:1,
          removeNTP: 'NTP-',
          removeHP: 'HP-',
          beforeCreatedAt: currentRegister(),
          sortType: true,
          // statusId: `${orderSaleStatus},${orderTransferStatus},${orderSoldStatus}`,
          demoStatus: "Demo_Completed,Demo_Cancelled,Available_For_Demo",
        }
  }

    getProduct(size, filterData)
      .then((data) => {
        let product = data.response.content;
        product.forEach(element => {
          const wtJson = JSON.parse(element.weight);
          element.purity = wtJson.purity;
          element.grossWeight = wtJson.grossWeight;
          element.netWeight = wtJson.netWeight;
          element.lessWeight = wtJson.lessWeight;
        });
        setProductList(product);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        // setLoading(true);
      });
  };

  const getOrderStatus = async () => {
    try {
      const data = await orderStatus({
        multiOrderStatus: "sale,Transferred,Sold",
      });

      if (!data || !data.response) {
        console.error("Invalid API response:", data);
        return;
      }
      const statusResponse = data.response;
      orderStatusSale.length = 0;
      orderStatusTransfer.length = 0;
      orderStatusSold.length = 0;
      statusResponse.forEach((item) => {
        const status = item.orderStatusName.toLowerCase();
        if (status === "sale") {
          orderStatusSale.push(item.id);
        } else if (status === "transferred") {
          orderStatusTransfer.push(item.id);
        } else if (status === "sold") {
          orderStatusSold.push(item.id);
        }
      });

      setOrderStatusSale(orderStatusSale);
      setOrderStatusTransfer(orderStatusTransfer);
      setOrderStatusSold(orderStatusSold);
    } catch (err) {
      console.error("API Error:", err);
    }
  };

  const getProductType = async () => {
    let pList = [];
    setListLoading(true);
    await getPageProductType({ active: 1 }).then((data) => {
      setListLoading(true);
      productType.length = 0;
      let response = data.response.content;
      pList = response.filter(
        (data) => data.metaProductCategoryList.length > 0 && data.id
      );
      pList.reverse();
      for (let index = 0; index < pList.length; index++) {
        productType.push(pList[index]);
      }
      setProductType(productType);
      setListLoading(false);
    });
  };

  const getCategoryList = async () => {
    setListLoading(true);
    let visibilityList = [];
    let filterData = {
      metaProdTypeEnty: selectedList.type ? selectedList.type : "",
      // visibilityMode: "WEB_MOBILE,MOBILE",
    };
    if (filterData.metaProdTypeEnty === "") {
      delete filterData.metaProdTypeEnty;
    }
    await getAllProductCate(filterData).then((data) => {
      const productResponse = data.response;
      visibilityList = productResponse.filter(
        (item) =>
          item.visibilityMode === "WEB_MOBILE" ||
          item.visibilityMode === "MOBILE"
      );
      setCategoryList(visibilityList);
      setListLoading(false);
    });
  };

  const getProductSub = async () => {
    setListLoading(true);
    let filterData = {
      metaProdTypeEnty: selectedList.type ? selectedList.type : "",
      metaProdCateEnty: selectedList.category ? selectedList.category : "",
    };
    if (filterData.metaProdTypeEnty === "") {
      delete filterData.metaProdTypeEnty;
    }
    if (filterData.metaProdCateEnty === "") {
      delete filterData.metaProdCateEnty;
    }
    await getAllProductSubCate(filterData).then((data) => {
      let response = data.response;
      setProductSubCate(response);
      setListLoading(false);
    });
  };

  const handleChange = (e, name) => {
    let target = e.target;
    let input = target.name;
    let value = target.value;

    if (input === "type") {
      setSelectedList({
        ...selectedList,
        type: value,
        category: "",
        subCategory: "",
        typeName: name,
        categoryName: "",
        subCategoryName: "",
      })
    } else if (input === "category") {
      setSelectedList({
        ...selectedList,
        category: value,
        subCategory: "",
        categoryName: name,
        subCategoryName: "",
      });
    } else if (input === "subCategory") {
      setSelectedList({
        ...selectedList,
        subCategory: value,
        subCategoryName: name,
      });
    } else if (input === "gender") {
      setSelectedList({
        ...selectedList,
        gender: value,
        genderName: name,
      });
    } else if (input === "status") {
      setSelectedList({
        ...selectedList,
        status: value,
        statusName: name,
      });
    } else if (input === 'minValue') {
      setSelectedList({
        ...selectedList,
        minValue: value,

      })
    } else if (input === 'maxValue') {
      setSelectedList({
        ...selectedList,
        maxValue: value,
      })
    }
  };

  //eslint-disable-next-line
  const dayCloseDay = () => {
    dayClose({
      module: "Sales",
      branchId: getBranchId(),
    }).then((data) => {
      if (data.response.length > 0) {
        let dateString = data.response[0].activeDate;
        let date = moment(dateString, "MMM DD, YYYY, h:mm:ss A");
        let dayCloseDate = date.format("YYYY-MM-DD");
        setDayClosedDates(dayCloseDate);
      }
    });
  };

  const searchOccasion = (value) => {
    handleClose(true);
    navigate("/ProductList", {
      state: {
        occasionCate: value
      }
    })
  }

  const Close = () => setSort(false);
  const goldFilter = (item) => {

  }

  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      console.log(productFilter, "[Updated productFilter]");
    }
  }, [productFilter]);

  const getProductList = () => {
    handleClose(true)
    setLoading(true);

    let filterData = {
      totalAmtFrom: selectedList.minValue,
      totalAmtTo: selectedList.maxValue,
      removeNTP: "NTP-",
      removeHP: "HP-",
      beforeCreatedAt: filterFormatToDate(moment().format('YYYY-MM-DD')),
      branch: getBranchId(),
      type: selectedList.type || '',
      metaProdCateEnty: selectedList.category || '',
      productSubcategory: selectedList.subCategory || '',
      userType: selectedList.gender || "",
      type: selectedList.type || '',
      status: "available",
      allowCatalogue: 1,
      productDemoStatus: "Available_For_Demo,Demo_Completed,Demo_Cancelled",
      statusId:
        selectedList.status === "allStatus"
          ? `${orderStatusSale},${orderStatusTransfer},${orderStatusSold}`
          : `${orderStatusSale},${orderStatusTransfer}`,
    };
    Object.keys(filterData).forEach((key) => {
      if (filterData[key] === "") delete filterData[key];
    });
    if (
      orderStatusSale.length > 0 &&
      orderStatusTransfer.length > 0 &&
      orderStatusSold.length > 0
    ) {
      getProduct(size, filterData)
        .then((data) => {
          if (typeof data.response === "string") {
            let parsedResponse = JSON.parse(data.response);

            setProductList(parsedResponse.content);
          } else {
            setProductList(data.response.content);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error("Product API Error:", err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  const getBanner = () => {
    configImages &&
      configImages.E_COMMERCE_BANNERS.forEach((data) => {
        if (data.key === "productList") {
          setBanner(data.value);
        }
      });
  };

  const wishCountFunc = (product) => {
    if (getCustomerId() && getCustomerId() !== "onlinepayment") {
      const productId = product.productId ? product.productId : product.id;
      setWishState((prevState) => ({
        ...prevState,
        [productId]: !prevState[productId],
      }));

      if (wishState[productId]) {
        const deletWish = `customerId=${getCustomerId()}&productId=${productId}`;
        deleteCustomerWish(deletWish);
      } else {
        const createWish = `customerId=${getCustomerId()}&productId=${productId}&remark=liked`;
        createCustomerWish(createWish);
      }
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };

  const likeCountFunc = (product) => {
    if (getCustomerId() && getCustomerId() !== "onlinepayment") {
      const productId = product.productId ? product.productId : product.id;
      setLikeState((prevState) => ({
        ...prevState,
        [productId]: !prevState[productId],
      }));

      if (likeState[productId]) {
        const deletLike = `customerId=${getCustomerId()}&productId=${productId}`;
        deleteCustomerLike(deletLike);
      } else {
        const createLike = `customerId=${getCustomerId()}&productId=${productId}&remark=liked`;
        createCustomerLike(createLike);
      }
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };

  const handleOpenDetails = (categoryItem) => {
    window.open(`/ProductDetails/${categoryItem.id}`, "_blank");
  };
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const [show, setShow] = useState(false);
  const [sort, setSort] = useState(false);

  const handleSortShow = () => setSort(true);
  const Closed = () => setSort(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showModal, setShowModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogin = (event) => {
    event.preventDefault();
    const username = event.target.username.value;
    const password = event.target.password.value;

    if (username === 'user' && password === 'password') {
      alert('Login successful!');
      setIsLoggedIn(true);
      setShowModal(false);
    } else {
      alert('Invalid username or password');
    }
  };

  const [selectedSort, setSelectedSort] = useState("Best Matches");
  const handleLogout = () => {
    alert('Logged out successfully!');
    setIsLoggedIn(false);
  };
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
  const [showMore, setShowMore] = useState(false);
  const [totalClicks, setTotalClicks] = useState(0);

  const handleToggle = () => {
    setShowMore((prev) => !prev);
  };

  const handleButtonClick = () => {
    setTotalClicks(prev => prev + 1);
  };

  const handleSeeMoreClick = () => {
    setShowMore(true);
  };

  const getOurExclusiveData = () => {
    getProductCate({
      visibilityMode: "DESIGN",
    })
      .then((data) => {
        setOccationCate(data.response.content);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // const handleClick = (categoryItem) => {
  //   navigate("/ProductList", { state: { occasionCate: categoryItem } });
  // };

return (
 <Container>
  <SEO
    title="ProductList - MGDM Jewellers"
    description="Beginner friendly page for learning React Helmet."
    name="Company name."
    type="article"
  />
  
  {/* Enhanced Breadcrumb */}
  <div className="px-lg-5 px-3" style={{ background: "linear-gradient(135deg, #f9f3f0 0%, #ffffff 100%)" }}>
    <nav className="py-3" aria-label="breadcrumb">
      <ol className="breadcrumb mb-0" style={{ fontSize: "14px" }}>
        <li className="breadcrumb-item">
          <Link to="/" className="text-decoration-none text-dark">
            <i className="bi bi-house-door me-1"></i>Home
          </Link>
        </li>
        <li className="breadcrumb-item active text-custom-100 fw-medium">
          {selectedList.typeName || selectedList.categoryName}
        </li>
      </ol>
    </nav>
  </div>

  <div className="container mt-2">
    {/* Page Header with Stats */}
    <div className="row align-items-center">
     


     {/* filters start */}
 <div className="col-md-8 m-0">
          <div className="d-flex flex-wrap gap-2">
            {/* Main Filter Button */}
            <button
              className="btn d-flex align-items-center gap-2 px-4 py-2 rounded-pill"
              onClick={handleShow}
              style={{
                background: "linear-gradient(135deg, #fff 0%, #f8f9fa 100%)",
                border: "2px solid #811331",
                color: "#5d4037",
                fontWeight: "600",
                height: "40px"
              }}
            >
              <i className="bi bi-funnel-fill" style={{ color: "#811331" }}></i>
              Filters
              {num > 0 && (
                <span className="badge rounded-pill ms-1" style={{ background: "#d4af37", color: "white" }}>
                  {num}
                </span>
              )}
            </button>

            {/* Quick Filter Chips - Fixed onClick handlers */}
            {occationCate
              .filter(categoryItem => categoryItem.displayName?.toLowerCase().trim() === "gifts")
              .map((categoryItem, index) => {
                const isSelected = selectedCategory === categoryItem.name;
                return (
                  <button
                    key={index}
                    className={`btn d-flex align-items-center gap-2 px-3 rounded-pill ${isSelected ? 'active' : ''}`}
                    onClick={() => {
                      if (isSelected) {
                        searchOccasion(null);
                        setSelectedCategory(null);
                        setNum(0);
                      } else {
                        searchOccasion(categoryItem.name);
                        setSelectedCategory(categoryItem.name);
                        setNum(prev => selectedCategory ? prev : prev + 1);
                      }
                    }}
                    style={{
                      background: isSelected ? "linear-gradient(135deg, #d4af37 0%, #c19a6b 100%)" : "white",
                      border: `2px solid ${isSelected ? '#d4af37' : '#e6ccb2'}`,
                      color: isSelected ? "white" : "#5d4037",
                      transition: "all 0.3s ease",
                      height: "40px"
                    }}
                  >
                    <i className={`bi ${isSelected ? 'bi-gift-fill' : 'bi-gift'}`}></i>
                    {categoryItem.displayName}
                  </button>
                );
              })}

            {/* Women's Collection Chip - Fixed onClick handler */}
            {genderImages
              .filter(image => image.title?.toLowerCase().trim() === 'female')
              .map((image, index) => {
                const isSelected = selectGenderCategory === image.gender;
                return (
                  <button
                    key={index}
                    className={`btn d-flex align-items-center gap-2 px-3 py-2 rounded-pill ${isSelected ? 'active' : ''}`}
                    onClick={() => {
                      if (isSelected) {
                        setSelectGenderCategory(null);
                        searchOccasion(null);
                        handleGenderSelection(null);
                        setNum(0);
                      } else {
                        setSelectGenderCategory(image.gender);
                        searchOccasion(image.gender);
                        handleGenderSelection(image.gender);
                        setNum(prev => selectGenderCategory ? prev : prev + 1);
                      }
                    }}
                    style={{
                      background: isSelected ? "linear-gradient(135deg, #ff6b9d 0%, #ff8fab 100%)" : "white",
                      border: `2px solid ${isSelected ? '#ff6b9d' : '#ffccd5'}`,
                      color: isSelected ? "white" : "#c2185b",
                      transition: "all 0.3s ease"
                    }}
                  >
                    <i className={`bi ${isSelected ? 'bi-gem' : 'bi-diamond'}`}></i>
                    Women's Collection
                  </button>
                );
              })}

              {/* <div className="d-flex align-items-center gap-3"> */}
             {/* <div className="position-relative">
               <h5 className="display-6 fw-bold mb-0" style={{ color: "#2c1810" }}>
                 {selectedList.typeName || selectedList.categoryName}
               </h5>
               <div className="position-absolute bottom-0 start-0 w-50" style={{ height: "3px", background: "#811331" }}></div>
             </div> */}
             {/* <span className="badge rounded-pill px-3 py-2" style={{color: "#8b4513", border: "1px solid #811331", fontSize: "14px", height: "40px"}}>
               {productList.length} Designs
            </span>
          </div> */}
          </div>

          {/* Expanded Filters (Show More Section) */}
          {showMore && (
            <div className="mt-3 pt-3 border-top">
              <div className="d-flex flex-wrap gap-2">
                {/* Gold Jewellery Filter - Fixed onClick handler */}
                {productType
                  .filter(data => data.name?.toLowerCase().trim() === "gold")
                  .map((data) => {
                    const isGoldSelected = selectGoldCategory === data.name;
                    return (
                      <button
                        key={data.id}
                        className={`btn d-flex align-items-center gap-2 px-3 py-2 rounded-pill ${isGoldSelected ? 'active' : ''}`}
                        onClick={() => {
                          if (isGoldSelected) {
                            searchOccasion(null);
                            setSelectGoldCategory(null);
                            setNum(0);
                          } else {
                            getProductList();
                            setSelectGoldCategory(data.name);
                            setGoldNum(!isGoldSelected ? goldNum + 1 : goldNum - 1);
                            setNum(prev => selectGoldCategory ? prev : prev + 1);
                          }
                        }}
                        style={{
                          background: isGoldSelected ? "linear-gradient(135deg, #FFD700 0%, #DAA520 100%)" : "white",
                          border: `2px solid ${isGoldSelected ? '#FFD700' : '#ffd966'}`,
                          color: isGoldSelected ? "white" : "#b8860b",
                          transition: "all 0.3s ease"
                        }}
                      >
                        <i className={`bi ${isGoldSelected ? 'bi-award-fill' : 'bi-award'}`}></i>
                        {data.name} Jewellery
                      </button>
                    );
                  })}

                {/* Earrings Filter - Fixed onClick handler */}
                {productCategory
                  .filter(data => data.categoryName?.toLowerCase().trim() === "earrings")
                  .map((data) => {
                    const isEarringSelected = selectEarringCategory === data.categoryName;
                    return (
                      <button
                        key={data.id}
                        className={`btn d-flex align-items-center gap-2 px-3 py-2 rounded-pill ${isEarringSelected ? 'active' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (isEarringSelected) {
                            searchOccasion(null);
                            setSelectEarringCategory(null);
                            setNum(0);
                          } else {
                            navigate(`/ProductList?category=${data.id}`, {
                              state: { category: data },
                            });
                            setSelectEarringCategory(data.categoryName);
                            setNum(prev => isEarringSelected ? prev : prev + 1);
                          }
                        }}
                        style={{
                          background: isEarringSelected ? "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)" : "white",
                          border: `2px solid ${isEarringSelected ? '#6a11cb' : '#a78bfa'}`,
                          color: isEarringSelected ? "white" : "#4c1d95",
                          transition: "all 0.3s ease"
                        }}
                      >
                        <i className={`bi ${isEarringSelected ? 'bi-check-circle-fill' : 'bi-plus-circle'}`}></i>
                        {toPascalCase(data.categoryName)}
                      </button>
                    );
                  })}

                {/* Pendants Filter - Fixed onClick handler */}
                {productCategory
                  .filter(data => data.categoryName?.toLowerCase().trim() === "pendants")
                  .map((data) => {
                    const isPendantsSelected = selectPendantsCategory === data.categoryName;
                    return (
                      <button
                        key={data.id}
                        className={`btn d-flex align-items-center gap-2 px-3 py-2 rounded-pill ${isPendantsSelected ? 'active' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (isPendantsSelected) {
                            searchOccasion(null);
                            setSelectPendantsCategory(null);
                            setNum(0);
                          } else {
                            navigate(`/ProductList?category=${data.id}`, {
                              state: { category: data },
                            });
                            setSelectPendantsCategory(data.categoryName);
                            setNum(prev => isPendantsSelected ? prev : prev + 1);
                          }
                        }}
                        style={{
                          background: isPendantsSelected ? "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)" : "white",
                          border: `2px solid ${isPendantsSelected ? '#6a11cb' : '#a78bfa'}`,
                          color: isPendantsSelected ? "white" : "#4c1d95",
                          transition: "all 0.3s ease"
                        }}
                      >
                        <i className={`bi ${isPendantsSelected ? 'bi-check-circle-fill' : 'bi-plus-circle'}`}></i>
                        {toPascalCase(data.categoryName)}
                      </button>
                    );
                  })}

                {/* Mangalsutras Filter - Fixed onClick handler */}
                {productCategory
                  .filter(data => data.categoryName?.toLowerCase().trim() === "mangalsutras")
                  .map((data) => {
                    const isMangalsutrasSelected = selectMangalsutrasCategory === data.categoryName;
                    return (
                      <button
                        key={data.id}
                        className={`btn d-flex align-items-center gap-2 px-3 py-2 rounded-pill ${isMangalsutrasSelected ? 'active' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (isMangalsutrasSelected) {
                            searchOccasion(null);
                            setSelectMangalsutrasCategory(null);
                            setNum(0);
                          } else {
                            navigate(`/ProductList?category=${data.id}`, {
                              state: { category: data },
                            });
                            setSelectMangalsutrasCategory(data.categoryName);
                            setNum(prev => isMangalsutrasSelected ? prev : prev + 1);
                          }
                        }}
                        style={{
                          background: isMangalsutrasSelected ? "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)" : "white",
                          border: `2px solid ${isMangalsutrasSelected ? '#6a11cb' : '#a78bfa'}`,
                          color: isMangalsutrasSelected ? "white" : "#4c1d95",
                          transition: "all 0.3s ease"
                        }}
                      >
                        <i className={`bi ${isMangalsutrasSelected ? 'bi-check-circle-fill' : 'bi-plus-circle'}`}></i>
                        {toPascalCase(data.categoryName)}
                      </button>
                    );
                  })}
              </div>
            </div>
          )}

          {/* Show More/Less Button */}
          <button
            onClick={handleToggle}
            className="btn btn-link text-decoration-none px-0"
            style={{ color: "#811331", fontSize: "14px" }}
          >
            <i className={`bi ${showMore ? 'bi-chevron-up' : 'bi-chevron-down'} me-1`}></i>
            {showMore ? "Show Less" : "Show More Filters"}
          </button>

           
        </div>
        {/* filters end */}


       <div className="col-md-4 text-end">
          {/* Sort Button */}
          <button
            className="btn d-flex align-items-center justify-content-center gap-2 px-4 py-2 rounded-pill ms-auto"
            onClick={handleSortShow}
            style={{
              background: "white",
              border: "2px solid #811331",
              color: "#5d4037",
              fontWeight: "600",
              minWidth: "200px"
            }}
          >
            <i className="bi bi-sort-down" style={{ color: "#811331" }}></i>
            Sort: {selectedSort}
            <i className="bi bi-chevron-down"></i>
          </button>
        </div>
    </div>

    {/* Active Filters Display */}
    {Object.keys(selectedList).some(key => selectedList[key]) && (
      <div>
        <div className="d-flex align-items-center gap-2 mb-2">
          <small className="text-muted">Active filters:</small>
          <button
              className="btn btn-sm btn-link text-decoration-none"
              onClick={() => {
                setNum(0);
                setSelectedCategory(null);
                searchOccasion(null);
                setSelectGenderCategory(null);
                setSelectedList({});
            }}
            style={{ color: "#dc3545", fontSize: "12px" }}
          >
            Clear all
          </button>
        </div>
        {/* <div className="d-flex flex-wrap gap-2">
          {selectedList.typeName && (
            <span className="badge d-flex align-items-center gap-1 px-3 py-2 rounded-pill" style={{ background: "#e8f4f8", color: "#0d6efd" }}>
              {selectedList.typeName}
              <i className="bi bi-x cursor-pointer" onClick={() => setSelectedList({...selectedList, type: "", typeName: ""})}></i>
            </span>
          )}
          {selectedList.categoryName && (
            <span className="badge d-flex align-items-center gap-1 px-3 py-2 rounded-pill" style={{ background: "#f0f9ff", color: "#0dcaf0" }}>
              {selectedList.categoryName}
              <i className="bi bi-x cursor-pointer" onClick={() => setSelectedList({...selectedList, category: "", categoryName: ""})}></i>
            </span>
          )}
          {selectedList.genderName && (
            <span className="badge d-flex align-items-center gap-1 px-3 py-2 rounded-pill" style={{ background: "#fff0f6", color: "#d63384" }}>
              {selectedList.genderName}
              <i className="bi bi-x cursor-pointer" onClick={() => setSelectedList({...selectedList, gender: "", genderName: ""})}></i>
            </span>
          )}
        </div> */}
      </div>
    )}

    {/* Products Grid - Enhanced Design */}
    <div className="pb-5">
     {/* No Products Found State */}
{!loading && productList && productList.length === 0 && (
  <div className="text-center py-5 my-5">
    <div className="mb-4">
      <i className="bi bi-gem display-1" style={{ color: "#e6ccb2" }}></i>
    </div>
    <h4 className="mb-3" style={{ color: "#5d4037" }}>No Products Found</h4>
    <p className="text-muted mb-4">Try adjusting your filters to find what you're looking for</p>
    <button
      className="btn rounded-pill px-4 py-2"
      onClick={() => {
        setNum(0);
        setSelectedCategory(null);
        searchOccasion(null);
        setSelectGenderCategory(null);
        setSelectedList({});
      }}
      style={{
        background: "linear-gradient(135deg, #d4af37 0%, #c19a6b 100%)",
        color: "white",
        border: "none"
      }}
    >
      Clear All Filters
    </button>
  </div>
)}

{/* Loading State */}
{loading && (
  <div className="row g-4">
    {[1, 2, 3, 4].map((_, index) => (
      <div key={index} className="col-md-6 col-lg-4 col-xl-3">
        <div className="card h-100 border-0 shadow-sm">
          <div className="card-img-top placeholder-glow" style={{ height: "280px", background: "#f0f0f0" }}>
            <div className="placeholder w-100 h-100"></div>
          </div>
          <div className="card-body">
            <h5 className="card-title placeholder-glow">
              <span className="placeholder col-8"></span>
            </h5>
            <p className="card-text placeholder-glow">
              <span className="placeholder col-6"></span>
            </p>
          </div>
        </div>
      </div>
    ))}
  </div>
)}

{/* Products Grid - Only show when not loading and products exist */}
{!loading && productList && productList.length > 0 && (
  <div className="row g-4">
    {[...productList]
      .sort((a, b) => {
        const wImage = a.images && a.images !== '@#@';
        const withoutImage = b.images && b.images !== '@#@';
        return wImage === withoutImage ? 0 : wImage ? -1 : 1;
      })
      .map((categoryItem, index) => (
        <div key={index} className="col-md-6 col-lg-4 col-xl-3">
          <div className="card h-100 border-0 shadow-sm hover-shadow transition-all position-relative overflow-hidden" 
               style={{ 
                 transition: "transform 0.3s ease, box-shadow 0.3s ease",
                 cursor: "pointer"
               }}
               onMouseEnter={e => e.currentTarget.style.transform = "translateY(-8px)"}
               onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
               onClick={() => handleOpenDetails(categoryItem)}>
            
            {/* Badges */}
            <div className="position-absolute top-0 start-0 z-2 p-3">
              {categoryItem.stockStatus === "Sale" && (
                <img src={bestSeller} ></img>
              )}
              {categoryItem.stockStatus.toLowerCase() === 'sold' && (
                <span className="badge rounded-pill px-3 py-1" style={{ background: "#6c757d", color: "white" }}>
                  Sold
                </span>
              )}
            </div>

            {/* Action Buttons */}
            <div className="position-absolute top-0 end-0 z-2 p-3 d-flex flex-column gap-2">
              <button 
                className="btn btn-light btn-sm rounded-circle shadow-sm p-2"
                onClick={(e) => {
                  e.stopPropagation();
                  wishCountFunc(categoryItem);
                }}
                style={{ width: "36px", height: "36px" }}>
                <i className={`bi ${wishState[categoryItem.id] ? 'bi-heart-fill text-danger' : 'bi-heart'}`}></i>
              </button>
              <button 
                className="btn btn-light btn-sm rounded-circle shadow-sm p-2"
                onClick={(e) => {
                  e.stopPropagation();
                  likeCountFunc(categoryItem);
                }}
                style={{ width: "36px", height: "36px" }}>
                <i className={`bi ${likeState[categoryItem.id] ? 'bi-hand-thumbs-up-fill text-primary' : 'bi-hand-thumbs-up'}`}></i>
              </button>
            </div>

            {/* Product Image */}
            <div className="card-img-top overflow-hidden position-relative" style={{ height: "280px", background: "#f9f3f0" }}>
              <img
                src={categoryItem.images === "@#@" ? noimg : categoryItem.images.split("@#@")[0]}
                alt={categoryItem.title}
                className="img-fluid w-100 h-100 object-fit-cover transition-transform"
                style={{ transition: "transform 0.5s ease" }}
                onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
                onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
              />
              <div className="position-absolute bottom-0 start-0 end-0 p-3" 
                   style={{ 
                     background: "linear-gradient(transparent, rgba(0,0,0,0.7))",
                     color: "white" 
                }}>
                {/* <small className="d-block opacity-75">Click to view details</small> */}
              </div>
            </div>

            {/* Product Info */}
            <div className="card-body">
  <h6 className="card-title fw-semibold mb-2 text-truncate" style={{ color: "#2c1810" }}>
    {toPascalCase(categoryItem.title)}
  </h6>

  <div className="d-flex justify-content-between align-items-start mt-3">
    <div style={{ minWidth: "60%" }}>
      {categoryItem.stockStatus.toLowerCase() !== 'sold' && categoryItem.total > 0 && (
        <div className="d-flex flex-column">
          <div className="d-flex align-items-baseline">
            <span className="fs-4 fw-bold" style={{ color: "#811331" }}>
              ₹{Math.trunc(categoryItem.total).toLocaleString('en-IN')}
            </span>
            {/* <small className="text-muted ms-2" style={{ fontSize: "0.8rem" }}>
              Incl. taxes
            </small> */}
          </div>
        </div>
      )}
      
      {categoryItem.stockStatus.toLowerCase() === 'sold' && (
        <div style={{ height: "3rem", display: "flex", alignItems: "center" }}>
          <span className="text-muted fst-italic">Contact for price</span>
        </div>
      )}
    </div>

    {/* Right side - Purity and Weight */}
    {categoryItem.stockStatus.toLowerCase() !== 'sold' && categoryItem.total > 0 && (
      <div className="d-flex flex-column align-items-end text-end" style={{ minWidth: "40%" }}>
        {categoryItem.purity && (
          <div className="mb-1">
            <span className="fw-medium" style={{ fontSize: "0.9rem", color: "#2c1810" }}>
              {categoryItem.purity}
            </span>
          </div>
        )}
        
        {categoryItem.grossWeight && (
          <div>
            <small className="text-muted" style={{ fontSize: "0.8rem" }}>
              G.Wt: {categoryItem.grossWeight}
            </small>
          </div>
        )}
      </div>
    )}
  </div>
</div>

            {/* Quick Actions */}
            {/* <div className="card-footer border-0 bg-transparent pt-0">
              <button 
                className="btn w-100 rounded-pill py-2"
                style={{
                  background: "linear-gradient(135deg, #d4af37 0%, #c19a6b 100%)",
                  color: "white",
                  border: "none",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={e => e.currentTarget.style.transform = "scale(1.02)"}
                onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                onClick={() => handleOpenDetails(categoryItem)}>
                <i className="bi bi-eye me-2"></i>
                View Details
              </button>
            </div> */}
          </div>
        </div>
      ))}
  </div>
)}

      {/* Load More Button */}
      {productList && productList.length > 0 && (
        <div className="text-center mt-5 pt-3">
          <button
            className="btn px-5 py-3 rounded-pill"
            onClick={() => setSize(size + 3)}
            disabled={loading}
            style={{
              background: loading ? "#e9ecef" : "white",
              border: "2px solid #d4af37",
              color: loading ? "#6c757d" : "#d4af37",
              fontWeight: "600",
              minWidth: "200px",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={e => {
              if (!loading) {
                e.currentTarget.style.background = "#d4af37";
                e.currentTarget.style.color = "white";
              }
            }}
            onMouseLeave={e => {
              if (!loading) {
                e.currentTarget.style.background = "white";
                e.currentTarget.style.color = "#d4af37";
              }
            }}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Loading...
              </>
            ) : (
              <>
                <i className="bi bi-plus-circle me-2"></i>
                Load More Designs
              </>
            )}
          </button>
        </div>
      )}
    </div>
  </div>

  {/* Enhanced Offcanvas Filter */}
  <Offcanvas 
    show={show} 
    onHide={handleClose} 
    placement="start" 
    className="border-0"
    style={{ width: "350px" }}>
    <Offcanvas.Header className="border-bottom" style={{ background: "linear-gradient(135deg, #811331 0%, #811331 100%)", color: "white" }}>
      <Offcanvas.Title className="w-100">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h5 className="mb-0">Filters</h5>
            <small className="opacity-75">Refine your selection</small>
          </div>
          <button 
            type="button" 
            className="btn-close btn-close-white" 
            onClick={handleClose}
            aria-label="Close"
          ></button>
        </div>
      </Offcanvas.Title>
    </Offcanvas.Header>
    
    <Offcanvas.Body className="p-0">
      <Accordion defaultActiveKey="0" flush>
        <Accordion.Item eventKey="1">
          <Accordion.Header className="fw-medium">Jewellery Type</Accordion.Header>
          <Accordion.Body>
            <div className="d-flex flex-wrap gap-2">
                {productType.map((item) => (
                  <button
                    key={item.id}
                    className={`btn btn-sm rounded-pill px-3 ${selectedList.type === item.id ? 'btn-custom-red' : 'btn-outline-mgdm'}`}
                    onClick={() => {
                      navigate(`/ProductList?type=${item.id}`, {
                        state: { type: item }
                      });
                    }}
                >
                  {item.name}
                </button>
              ))}
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header className="fw-medium">Product Category</Accordion.Header>
          <Accordion.Body>
            <div className="d-flex flex-wrap gap-2">
              {productCategory
                .filter((item, index, self) =>
                  index === self.findIndex((t) => t.categoryName === item.categoryName)
                )
                .map((data) => (
                  <button
                    key={data.id}
                    className={`btn btn-sm rounded-pill px-3 ${selectedList.category === data.id ? 'btn-custom-red' : 'btn-outline-mgdm'}`}
                    onClick={() => {
                      navigate(`/ProductList?category=${data.id}`, {
                        state: { category: data }
                      });
                    }}
                  >
                    {toPascalCase(data.categoryName)}
                  </button>
                ))}
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header className="fw-medium">Gender</Accordion.Header>
          <Accordion.Body>
            <div className="d-flex flex-wrap gap-2">
              {genderImages.map((image, index) => (
                <button
                  key={index}
                  className={`btn btn-sm rounded-pill px-3 ${selectedList.gender === image.gender ? 'btn-custom-red' : 'btn-outline-mgdm'}`}
                  onClick={() => handleGenderSelection(image.gender)}
                >
                  {toPascalCase(image.title)}
                </button>
              ))}
            </div>
          </Accordion.Body>
        </Accordion.Item>

        {/* <Accordion.Item eventKey="5">
          <Accordion.Header className="fw-medium">
            Occasion {num > 0 && <span className="text-warning">({num})</span>}
          </Accordion.Header>
          <Accordion.Body>
            <div className="d-flex flex-wrap gap-2">
              {occationCate.map((categoryItem, index) => (
                <button
                  key={index}
                  className={`btn btn-sm rounded-pill px-3 ${selectedCategory === categoryItem.name ? 'btn-custom-red' : 'btn-outline-mgdm'}`}
                  onClick={() => {
                    if (selectedCategory === categoryItem.name) {
                      searchOccasion(null);
                      setSelectedCategory(null);
                      setNum(0);
                    } else {
                      searchOccasion(categoryItem.name);
                      setSelectedCategory(categoryItem.name);
                      setNum(1);
                    }
                  }}
                >
                  {toPascalCase(categoryItem.displayName)}
                </button>
              ))}
            </div>
          </Accordion.Body>
        </Accordion.Item> */}

        <Accordion.Item eventKey="6">
          <Accordion.Header className="fw-medium">Metal</Accordion.Header>
          <Accordion.Body>
            <div className="d-flex flex-wrap gap-2">
              {productType.map((data) => (
                <button
                  key={data.id}
                  className={`btn btn-sm rounded-pill px-3 ${selectedList.type === data.id ? 'btn-custom-red' : 'btn-outline-mgdm'}`}
                  onClick={() => {
                    navigate(`/ProductList?type=${data.id}`, {
                      state: { type: data }
                    });
                  }}
                >
                  {data.name}
                </button>
              ))}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Offcanvas.Body>
    
    <div className="border-top p-3 bg-light">
      <div className="d-grid gap-2">
        <button 
          className="btn rounded-pill py-2"
          onClick={() => {
            setNum(0);
            setSelectedCategory(null);
            searchOccasion(null);
            setSelectGenderCategory(null);
            setSelectedList({});
          }}
          style={{
            background: "white",
            border: "2px solid #811331",
            color: "#811331"
          }}
        >
          <i className="bi bi-x-circle me-2"></i>
          Clear All Filters
        </button>
        <button 
          className="btn rounded-pill py-2"
          onClick={() => {
            getProductList();
            handleClose();
          }}
          style={{
            background: "linear-gradient(135deg, #811331 0%, #811331 100%)",
            border: "none",
            color: "white"
          }}
        >
          <i className="bi bi-check-circle me-2"></i>
          Apply Filters
        </button>
      </div>
    </div>
  </Offcanvas>

  {/* Sort Modal */}
  <Modal show={sort}  centered className="border-0">
    <Modal.Body className="p-0 rounded-3 overflow-hidden">
      <div className="p-3 border-bottom d-flex justify-content-between align-items-center" style={{ background: "#811331" }}>
        <h6 className="mb-0 fw-bold text-white">Sort By</h6>
        <button 
          type="button" 
          className="btn-close btn-close-white" 
          onClick={Closed}
          aria-label="Close"
        ></button>
      </div>
      <div className="list-group list-group-flush">
        {sortOptions.map((option, index) => (
          <button
            key={index}
            className={`list-group-item list-group-item-action border-0 py-3 ${selectedSort === option.label ? 'active' : ''}`}
            style={{
              background: selectedSort === option.label ? "#f0e6d6" : "transparent",
              color: selectedSort === option.label ? "#d4af37" : "#5d4037",
              borderLeft: selectedSort === option.label ? "3px solid #d4af37" : "3px solid transparent"
            }}
            onClick={() => {
              setSelectedSort(option.label);
              navigate(option.route);
              handleClose();
            }}
          >
            {option.label}
          </button>
        ))}
      </div>
    </Modal.Body>
  </Modal>
</Container>
);
};